import UserLogsPage from "../../../features/admin/user-log/user-logs-page";

export default function UserLog() {
  return <UserLogsPage />;
}
